export function nonEmpty(value, placeholder = '-') {
    if (value === undefined) return placeholder
    if (value === null) return placeholder
    if (typeof value !== 'string') return placeholder
    if (value.trim().length === 0) return placeholder
    return value
}
